<template>
  <div>
    <!-- BootstrapVue Done -->
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-info">
      <b-row>
        <!-- <b-col xl="3" md="6">
          <stats-card type="gradient-info" icon="ni ni-chart-bar-32" class="mb-4">
            <h5 class="card-title text-uppercase text-muted mb-0">
              RESPON RATE
            </h5>
            <span class="h2 font-weight-bold mb-0">{{ totalMengisi }}</span>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card type="gradient-info" icon="ni ni-chart-bar-32" class="mb-4">
            <h5 class="card-title text-uppercase text-muted mb-0">
              RESPON PERUSAHAAN
            </h5>
            <span class="h2 font-weight-bold mb-0">{{ totalAlumni }}</span>
          </stats-card>
        </b-col> -->
      </b-row>
    </base-header>

    <b-container fluid class="mt--7">
      <b-row class="justify-content-center">
        <b-col lg="12">
          <card header-classes="bg-transparent">
            <!--Tables-->
            <b-row class="mt-2">
              <b-col xl="12" class="mb-5 mb-xl-0">
                <b-card body-class="p-0" header-class="border-0">
                  <template v-slot:header>
                    <b-row align-v="center">
                      <b-col>
                        <h3 class="mb-0">Data Hasil Survey</h3>
                      </b-col>
                      <!-- <b-col class="text-right">
                        <a href="#!" class="btn btn-sm btn-primary"><i class="ni ni-fat-add"></i>Tambah Data</a>
                      </b-col> -->
                    </b-row>
                  </template>

                  <div class="padding">
                    <div v-show="loading">
                      <Loading />
                    </div>
                    <b-col class="text-right">
                      <button @click="downloadFile()" class="btn btn-sm btn-default">
                        <i class="fa fa-download mr-2"></i>Download Data
                      </button>
                      <select name="tahun" @change="getFilterTahun" class="text-left mr-2" v-model="selected">
                        <option value="" disabled>Pilih Tahun Wisuda</option>
                        <option v-for="periode in list_tahun_periode" :key="periode.tahun" :value="periode.tahun">
                          {{ periode.tahun }}
                        </option>
                      </select>
                      <!-- <select name="study_program" @change="getPrograms" class="text-left" v-model="selected_prodi">
                        <option value="" disabled>Pilih Program Studi</option>
                        <option v-for="study_program in study_programs" :key="study_program.id_program_studi"
                          :value="study_program.id_program_studi">
                          {{ study_program.jenjang }} -
                          {{ study_program.nm_program_studi }}
                        </option>
                      </select> -->
                    </b-col>
                    <v-client-table :data="tableData" :columns="columns" :options="options">
                     <template slot="no_pengisian" slot-scope="{ row }">
                        Pengisisan Ke- {{row.no_pengisian}}
                      </template>
                      <template slot="status_mengisi" slot-scope="{ row }">
                        <button v-if="row.status_mengisi == 1" class="btn btn-sm btn-success">
                          sudah
                        </button>
                        <button v-if="row.status_mengisi == 0" class="btn btn-sm btn-danger">
                          belum
                        </button>
                      </template>
                      <template slot="actions" slot-scope="{ row }">
                        <button @click="detailItem(row)" class="btn btn-sm btn-info">
                          <i class="ni ni-curved-next mr-1"></i>detail
                        </button>
                      </template>
                    </v-client-table>
                  </div>
                </b-card>
              </b-col>
            </b-row>
            <!--End tables-->
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import BaseHeader from "@/components/admin/BaseHeader";
import DataService from "@/services/data.service";
import Loading from "@/components/Loading.vue";

export default {
  name: "Alumni",
  components: {
    BaseHeader,
    Loading
  },
  data() {
    return {
      selected: "",
      selected_prodi: "",
      list_tahun_periode: {},
      study_programs: {},
      totalAlumni: "",
      totalMengisi: "",
      loading: false,
      columns: [
        "wkt_pengisian",
        "tanggal_wisuda",
        "nm_atasan",
        "nm_tmpt_bekerja",
        "npm",
        "nama_lengkap",
        "nm_fakultas",
        "nm_program_studi",
        "actions"
      ],
      tableData: [],
      options: {
        headings: {
          wkt_pengisian: "Waktu Pengisian  ",
          tanggal_wisuda: "Tanggal Wisuda  ",
          nm_atasan: "Nama Atasan  ",
          nm_tmpt_bekerja: "Tempat Bekerja  ",
          npm: "NPM  ",
          nama_lengkap: "Nama Lengkap  ",
          nm_fakultas: "fakultas  ",
          nm_program_studi: "Program Studi  ",
          actions: "Aksi "
        },
        sortable: true,
        filterable: true,
        hiddenColumns: ["id_alumni", "id_tracer_atasan"],
        texts: {
          count:
            "Menampilkan {from} sampai {to} dari {count} data|{count} data|Satu data",
          first: "Pertama",
          last: "Terahkir",
          filter: false,
          filterPlaceholder: "Pencarian",
          limit: false,
          page: "Page:",
          noResults: "Data tidak ada",
          loading: "Loading...",
          defaultOption: "Select {column}",
          columns: "Columns"
        },
        sortIcon: {
          is: "fa fa-sort",
          base: "font-awesome",
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          align: "center"
        },
        pagination: {
          show: true,
          dropdown: false,
          chunk: 5,
          edge: false,
          align: "center",
          nav: "fixed"
        }
      }
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  mounted() {
    this.getTahun();
    this.getPs();
    this.getHasilDudi();
  },
  methods: {
    detailItem(row) {
      this.$router.push({
        name: "detail-hasil-kuesioner-dudi",
        params: {
          id_tracer_atasan: row.id_tracer_atasan
        }
      });
    },
    downloadFile() {
      DataService.downloadFileDudiProdi(this.selected, this.currentUser.user.username)
        .then(res => {
          this.customDownload(res, "HasilDudi");
        })
        .catch(error => console.error(error));
    },
    customDownload(res, filename) {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([res.data], { type: "application/xlsx" });

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);
      var link = document.createElement("a");
      link.href = data;
      link.download = filename + ".xlsx";
      link.click();
      setTimeout(function() {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    },
    getTahun() {
      DataService.getTahunPeriode()
        .then(res => {
          this.list_tahun_periode = res.data.tahunPeriode;
        })
        .catch(error => console.error(error));
    },
    getPs() {
      DataService.getProdi()
        .then(res => {
          this.study_programs = res.data.studyPrograms;
        })
        .catch(error => console.error(error));
    },
    getPrograms() {
      this.loading = true;
      DataService.getProgramStudyTracer(this.selected, this.selected_prodi)
        .then(res => {
          this.tableData = res.data.surveys;
          this.totalAlumni = res.data.totalAlumni;
          this.totalMengisi = res.data.totalMengisi;
          if (this.tableData) {
            this.loading = false;
            return;
          }
        })
        .catch(error => console.error(error));
    },
    getHasilDudi() {
      this.loading = true;
      DataService.getHasilDudi(this.currentUser.user.username).then(res => {
        this.tableData = res.data.data;
        // this.totalAlumni = res.data.totalAlumni;
        // this.totalMengisi = res.data.totalMengisi;
        if (this.tableData) {
          this.loading = false;
          return;
        }
      });
    },
    getFilterTahun() {
      this.loading = true;
      DataService.getHasilDudiChoise(this.currentUser.user.username, this.selected)
        .then(res => {
          this.tableData = res.data.data;
          // this.totalAlumni = res.data.totalAlumni;
          // this.totalMengisi = res.data.totalMengisi;
          if (this.tableData) {
            this.loading = false;
            return;
          }
        })
        .catch(error => console.error(error));
    },
    sinkronItem() {
      this.$swal({
        title: "Yakin ingin sinkron data?",
        text:
          "Sinkron data akan memakan waktu untuk proses dan Pastikan tidak ada perubahan data",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sinkron Sekarang!",
        cancelButtonText: "Batal"
      }).then(result => {
        this.loading = true;
        if (result.value) {
          DataService.getSinkronHasilTracer(this.selected)
            .then(response => {
              this.$swal("Data berhasil disetor");
              this.getHasilTracer();
            })
            .catch(error => {
              this.$swal({
                icon: "error",
                title: "Data gagal disetor"
              });
              this.getHasilTracer();
            });
        }
        // this.loading = false;
      });
    }
  }
};
</script>
<style scoped>
.padding {
  padding: 20px !important;
}
</style>
